import RoomsIndexPreviewable from './RoomsIndexPreviewable';

export default RoomsIndexPreviewable;
